export const CONTENT_TYPE_JSON = 'application/json;charset=UTF-8';
export const CONTENT_TYPE_EXCEL = 'application/vnd.ms-excel';

export const ApiMethods = {
    CONNECT: 'CONNECT',
    DELETE: 'DELETE',
    GET: 'GET',
    HEAD: 'HEAD',
    OPTIONS: 'OPTIONS',
    POST: 'POST',
    PUT: 'PUT'
};
